import request from "@/utils/request";

export default function agentGetAccessControlDeviceHardwareConfig(ids) {
  return request.get(
    `/device/accessControlDeviceHardwareConfig/agent/getByIds?ids=${ids}`
  );
}
